export { default } from './TrailMetadata';
